import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { DishCreateNamePage } from "../dish-create/dish-create-name/dish-create-name";
import { DishViewPage } from "../dish-view/dish-view/dish-view";
import { DishServices } from "../services";
import { Globals } from "../../../globals";
import { ExportServices } from "../../services/exportServices";
import { ConfigurationServices } from '../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ImportExcelPage } from "../../components/import-excel/import-excel";
import { AdsServices } from '../../ads/services';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { TutorialDishesPage } from '../../help/tutorials/tutorial-dishes/tutorial-dishes';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the DishListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-list',
  templateUrl: 'dish-list.html',
})
export class DishListPage {
  //var
  name_dish: string;
  searchbar_text: string = '';
  loader_foodcost: boolean = true;
  loader_allergens: boolean = true;
  loader_categories: boolean = true;
  loader_total_dishes_sold: boolean = true;
  loader_dishes_sold_today: boolean = true;
  loader_most_sold_dish: boolean = true;
  show_tutorial: boolean = false;

  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' },
    { prop: 'pvp', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public dishServices: DishServices,
    public globals: Globals,
    public exportServices: ExportServices,
    public configurationServices: ConfigurationServices,
    public http: HttpClient,
    public translate: TranslateService,
    public adsServices: AdsServices) {
    this.globals.GAtrackView('Dish', 'Dish - List', this.globals.restaurant.email, 'View', 'List dishes', 'Dish', '');
    this.dishServices.getPagesDishes(0);
    //Tutorial Platos
    if (this.globals.restaurant.license == 'free') {
      this.show_tutorial = true;
      this.navCtrl.push(TutorialDishesPage);
    }

    if (this.globals.checkLimitsByLicense('dishes', 'analitycs')) {//Si analitycs activo para la version
      //analitics
      this.analyticsGetMostSoldDish();
      this.analyticsGetTotalNumberDishesSold();
      this.analyticsGetTotalDishesSoldToday();
    } else {
      this.loader_most_sold_dish = false;
      this.loader_total_dishes_sold = false;
      this.loader_dishes_sold_today = false;
    }
    if (this.globals.checkLimitsByLicense('dishes', 'analitycs')) {
      this.initGetFoodcostCategoryAllergens();
    } else {
      this.loader_foodcost = false;
      this.loader_allergens = false;
      this.loader_categories = false;
    }
  }

  //Analitica informació allergens, categories i foodcost
  async initGetFoodcostCategoryAllergens() {
    this.analyticsGetCategoryTotal();
    this.analyticsGetDishesFoodcostPercent();
    this.analyticsGetDishesAllergensTotal();
  }

  ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-platos')
    });
    //If para no mostrar el loader encima de la pagina del tutorial
    if (!this.show_tutorial) {
      loadingPopup.present();
    }
    // Los tags ya se cargan al inicio de la app en getAllTags()

    loadingPopup.dismiss();

    this.adsServices.randomProvidersElements();
    this.searchDishNode(this.searchbar_text);
  }

  openDishView(dish) {
    if (dish._active) {
      this.getDishLang(dish);
      this.dishServices.image_url_dish_view = null;
      this.navCtrl.push(DishViewPage, {
        dish_uid: dish.UID,
        dish_name: this.name_dish,
        dish_price: dish.price
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openDishCreate() {
    var total_dishes = 0;
    if (this.dishServices.dishes_array) {
      total_dishes = this.dishServices.dishes_array.length;
    }
    //Si total_dishes es mayor o igual al limite de platos, y el limite es diferente a -1
    if (total_dishes >= this.globals.checkLimitsByLicense('dishes', 'max_dishes') && this.globals.checkLimitsByLicense('dishes', 'max_dishes') != -1) {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      this.dishServices.image_url_dish_view = null;
      //
      this.globals.tourLaunchStep(2);
      //
      this.navCtrl.push(DishCreateNamePage, {
        update: false
      });
    }
  }

  async exportDishes() {
    //Preparar Json para exportar
    var _dishes = await this.dishServices.getDishes(this.globals.restaurant_uid);

    var data = [];
    var _dish = [];
    var _foodcost = [];

    for (let dish of _dishes) {
      var _array = {
        nombre_es: dish.name_es,
        nombre_ca: dish.name_ca,
        nombre_en: dish.name_en,
        nombre_de: dish.name_de,
        nombre_fr: dish.name_fr,
        nombre_it: dish.name_it,
        precio: dish.price,
        precio_medio: dish.price_half,
        precio_tapa: dish.price_tapa,
        elaboraicon: dish.recipe,
        tiempo: dish.time,
        herramientas: dish.tools,
        tags: dish.tags_static,
        racion: dish.foodcost_parts,
        precio_racion: dish.foodcost_static,
      };

      _dish.push(_array);

      for (let foodcost of dish.foodcost) {
        var _array_foodcost = {
          medida: foodcost.measurement_static,
          name: foodcost.name_static,
          precio: foodcost.price_static,
          precio_total: foodcost.pricetotal_static,
          proveedor: foodcost.provider_static,
          cantidad: foodcost.quantity,
          cantidad_con_merma: foodcost.quantity_gross,
          merma: foodcost.waste,
        };

        _foodcost.push(_array_foodcost);
      }

      var _array_data = {
        name: _dish[0].nombre_es,
        dish: _dish,
        foodcost: _foodcost,
      };

      data.push(_array_data);
      _dish = [];
      _foodcost = [];
    }

    //llamar funcion exportar
    this.exportServices.exportAsExcelFoodCost(data, 'platos');
  }

  //Analitics
  public mostDishSale: any = '';
  async analyticsGetMostSoldDish() {
    this.loader_most_sold_dish = true;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    //enviar post la peticion y devuelve el plato mas vendido del mes
    this.http.post(this.globals.analytics_path + 'bidish/get_most_sold_dish', params, {})
      .subscribe(res => {
        this.mostDishSale = res;
        if (this.mostDishSale != null) {
          this.mostDishSale = res[0];
        } else {
          this.mostDishSale = this.translate.instant('general-faltan-datos');
        }
        this.loader_most_sold_dish = false;
      });
  }

  public total_dishes_sold: any = '';
  async analyticsGetTotalNumberDishesSold() {
    this.loader_total_dishes_sold = true;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    //enviar post la peticion y devuelve el total de platos vendidos
    this.http.post(this.globals.analytics_path + 'bidish/get_total_dishes_sold', params, {})
      .subscribe(res => {
        this.total_dishes_sold = res;
        this.loader_total_dishes_sold = false;
      });
  }

  public dishes_sold_today: any = '';
  async analyticsGetTotalDishesSoldToday() {
    this.loader_dishes_sold_today = true;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    //enviar post la peticion y devuelve el plato mas vendido del mes
    this.http.post(this.globals.analytics_path + 'bidish/get_dishes_sold_today', params, {})
      .subscribe(res => {
        this.dishes_sold_today = res;
        this.loader_dishes_sold_today = false;
      });
  }

  profitFoodCost(price, foodcost) {
    //Quitamos el tax del precio
    price = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
    return 100 - this.globals.regla3(price, foodcost);
  }

  searchDishNode(value) {
    this.searchbar_text = value; //Guardamos el valor del searchbar
    this.dishServices.searchDishNode(value);
  }

  importDishes(type) {
    this.navCtrl.push(ImportExcelPage, {
      type: type
    })
  }
  getDishLang(dish) {
    if (this.globals.restaurant.lang == 'es') {
      this.name_dish = dish.name_es;
    } else if (this.globals.restaurant.lang == 'en') {
      this.name_dish = dish.name_en;
    } else if (this.globals.restaurant.lang == 'fr') {
      this.name_dish = dish.name_fr;
    } else if (this.globals.restaurant.lang == 'ca') {
      this.name_dish = dish.name_ca;
    } else if (this.globals.restaurant.lang == 'fr') {
      this.name_dish = dish.name_fr;
    } else if (this.globals.restaurant.lang == 'de') {
      this.name_dish = dish.name_de;
    } else if (this.globals.restaurant.lang == 'it') {
      this.name_dish = dish.name_it;
    }
  }

  //Analítica Categories Allergens Foodcost
  styleIcon(total, nombre_cat) {
    let styles = {
      'width': this.globals.regla3(total, nombre_cat) + '%',
    };
    return styles;
  }

  //Funció per a mostrar més categories
  public show_all_categories = false;
  change_show_categories() {
    if (this.show_all_categories) {
      this.show_all_categories = false;
    } else {
      this.show_all_categories = true;
    }
  }

  //Clic para buscar la categoria
  clic_buscar_categoria(categoria) {
    this.searchbar_text = categoria;
    //node
    this.searchDishNode(this.searchbar_text);
  }

  //Categories
  public category_desplegado = 0;
  public dishes_with_category = 0;
  public dishes_without_category = 0;
  public total_plats = 0;
  public category_cinc_primers = 0;
  async analyticsGetCategoryTotal() {
    this.loader_categories = true;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);

    //enviar post la peticion y devuelve el plato mas vendido del mes
    this.http.post(this.globals.analytics_path + 'bidish/get_category_total', params, {})
      .subscribe(res => {

        this.category_cinc_primers = res['category_sin_desplegar'];
        this.category_desplegado = res['category'];

        this.dishes_with_category = res['amb_categoria'];
        this.dishes_without_category = res['sense_categoria'];
        this.total_plats = res['total_plats'];

        this.loader_categories = false;
      });
  }

  //Foodcost
  public average_foodcost_percent = 0;
  public dishes_without_price = 0;
  public dishes_without_foodcost = 0;
  async analyticsGetDishesFoodcostPercent() {
    this.loader_foodcost = true;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);
    //enviar post la peticion y devuelve el plato mas vendido del mes
    this.http.post(this.globals.analytics_path + 'bidish/get_dishes_foodcost_percentatge', params, {})
      .subscribe(res => {
        this.average_foodcost_percent = Math.round(res['percentatge_foodcost']);
        this.dishes_without_price = res['plats_sense_price'];
        this.dishes_without_foodcost = res['plats_sense_foodcost'];
        this.loader_foodcost = false;
      });
  }

  //Funció per a mostrar més allergens
  public show_all_allergens = false;
  change_show_allergens() {
    if (this.show_all_allergens) {
      this.show_all_allergens = false;
    } else {
      this.show_all_allergens = true;
    }
  }

  //Allergens
  public allergens_cinc_primers = [];
  public allergens_tots = [];
  public number_of_dishes_with_allergens = 0;
  public number_of_dishes_without_allergens = 0;
  async analyticsGetDishesAllergensTotal() {
    this.loader_allergens = true;
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);
    //enviar post la peticion y devuelve el plato mas vendido del mes
    this.http.post(this.globals.analytics_path + 'bidish/get_dishes_allergens_total', params, {})
      .subscribe(res => {
        //Convertimos la id del allergeno en su nombre
        for (let allergen_id of res['allergens']) {
          this.allergens_cinc_primers.push({
            "name": this.globals.getAllergenName(allergen_id.id_allergen).replace('*', ''),
            "total": allergen_id.total,
          });
        }
        //Convertimos la id del allergeno en su nombre
        for (let aller_id of res['allergens_tot']) {
          this.allergens_tots.push({
            "name": this.globals.getAllergenName(aller_id.id_allergen).replace('*', ''),
            "total": aller_id.total,
          });
        }
        this.number_of_dishes_with_allergens = res['dishes_with_allergens'];
        this.number_of_dishes_without_allergens = res['dishes_without_allergens'];
        this.loader_allergens = false;
      });
  }

  clickElement(event) {
    if (event.type == 'click') {
      this.openDishView(event.row);
    }
  }

  onSort(event) {
    var dishes_array = [];
    if (this.dishServices.filteredDishesActive) {
      dishes_array = this.dishServices.filteredDishes;
    } else {
      dishes_array = this.dishServices.dishes_array;
    }

    switch (event.column.name) {
      case 'name':
        if (event.newValue == 'asc') {
          dishes_array.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));
        } else {
          dishes_array.sort((a, b) => this.globals.nameLangSelectDish(b).localeCompare(this.globals.nameLangSelectDish(a)));
        }
        break;
      case 'pvp':
        if (event.newValue == 'asc') {
          dishes_array.sort((a, b) => a.price - b.price);
        } else {
          dishes_array.sort((a, b) => b.price - a.price);
        }
        break;
    }
    if (this.dishServices.filteredDishesActive) {
      this.dishServices.filteredDishes = dishes_array;
      this.dishServices.filteredDishes = [...this.dishServices.filteredDishes];
    } else {
      this.dishServices.dishes_array = dishes_array;
      this.dishServices.dishes_array = [...this.dishServices.dishes_array];
    }
  }

  getRowClass(row) {
    return {
      'not-active': row._active === false
    };
  }

  filter(value) {
    var _return = [];
    this.dishServices.filteredDishesActive = false;

    if (value != undefined && value.length > 0) {
      this.dishServices.dishes_array.forEach(dish => {
        if (dish.name_es != undefined && dish.name_es.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(dish);
        } else if (dish.name_en != undefined && dish.name_en.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(dish);
        } else if (dish.name_ca != undefined && dish.name_ca.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(dish);
        } else if (dish.name_de != undefined && dish.name_de.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(dish);
        } else if (dish.name_fr != undefined && dish.name_fr.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(dish);
        } else if (dish.name_it != undefined && dish.name_it.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(dish);
        } else if (dish.tags_static != undefined && dish.tags_static.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(dish);
        } else if (dish.tags != undefined && dish.tags.toString().toLowerCase().includes(value.toLowerCase())) {
          _return.push(dish);
        } else if (dish.foodcost_static != undefined && dish.foodcost_static.toFixed(2).toString().replace(/\./g, ',').includes(value.replace(/\./g, ','))) {
          _return.push(dish);
        } else if (dish.price != undefined && dish.price.toFixed(2).toString().replace(/\./g, ',').includes(value.replace(/\./g, ','))) {
          _return.push(dish);
        }
      });
      this.dishServices.filteredDishesActive = true;
      this.dishServices.filteredDishes = _return;
      this.dishServices.filteredDishes = [...this.dishServices.filteredDishes];
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-list/dish-list.ts